var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.prompt()}}},[_vm._t("default",function(){return [_vm._m(0)]})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button is-white is-small"},[_c('div',{staticClass:"icon has-text-grey"},[_c('i',{staticClass:"mdi mdi-delete mdi-18px"})])])
}]

export { render, staticRenderFns }